import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import '../assets/css/general.css';
import aboutImage from '../assets/img/about.jpg';
// Import the new image
import productsBigbagImage from '../assets/img/products/bigbag/bigbag.jpg';


const About = () => {
  return (
    <main id="main" className="about-page">
      {/* ======= Breadcrumbs ======= */}
      <section id="breadcrumbs" className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/"><i className="fas fa-home"></i></Link></li>
            <li>About</li>
          </ol>
        </div>
      </section>{/* End Breadcrumbs */}

      {/* ======= About Section ======= */}
      <section id="about-content" className="about-content-section">
        <div className="container">
          <div className="section-title">
            <h2>About Us</h2>
            <div className="title-bar"></div>
          </div>
          
          <div className="about-container">
            <div className="content-column">
              <div className="about-card">
                <h3 className="about-subtitle">Our Story</h3>
                <p>
                  Founded in 2019, ABP Big Bags leverages over 20 years of industry expertise and a global network of partners to deliver exceptionally durable, 
                  high-performance bulk packaging solutions. 
                  Our founders’ deep economic and strategic insights ensure every product meets 
                  the exacting demands of today’s industries—from agriculture and construction to chemicals and mining.
                </p>
                <p>
                  Headquartered in Budapest, Hungary, directly on a major international shipping corridor, we combine strategic location with an ever-expanding logistics footprint. 
                  Having launched our operations in Turkey, ABP Big Bags now supports customers across Europe through 
                  dedicated warehouses and sales offices—bringing reliability, efficiency, and superior quality to every shipment
                </p>
              </div>
              
              <div className="about-card">
                <h3 className="about-subtitle">Our Approach</h3>
                <p>
                  This rapid and healthy growth is based on several success factors. These factors can be briefly
                  expressed as providing the highest quality products in the best and fastest way, as well as
                  honest and respectful interaction both internally and with our cooperation partners, and a
                  long-term, successful business relationship.
                </p>
                <p>
                  ABP bigbag is proud to expand its sales and distribution network with its strong partners.
                </p>
              </div>
            </div>
            
            <div className="image-column">
              <div className="image-wrapper">
                <img className="about-image" src={aboutImage} alt="About ABP Bigbag" />
                {/* The experience badge has been removed from here */}
              </div>
              {/* Added the new image below the first one */}
              <div className="image-wrapper" style={{ marginTop: '20px' }}>
                <img className="about-image" src={productsBigbagImage} alt="ABP Bigbag Products" />
              </div>
            </div>
          </div>

          <div className="mission-values-section">
            <div className="container">
              <div className="mission-values-wrapper">
                <div className="highlight-item">
                  <div className="highlight-icon">
                    <i className="fas fa-bullseye"></i>
                  </div>
                  <div className="highlight-content">
                    <h4>Our Mission</h4>
                    <p>To provide the highest customer satisfaction with sustainable and value-added products.</p>
                  </div>
                </div>
                
                <div className="highlight-item">
                  <div className="highlight-icon">
                    <i className="fas fa-gem"></i>
                  </div>
                  <div className="highlight-content">
                    <h4>Our Values</h4>
                    <p>Innovation, quality, mutual respect, long-term partnerships, reasonable prices and trust.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>{/* End Section */}
      
      {/* ======= Expertise Section ======= */}
      <section className="expertise-section">
        <div className="container">
          <div className="expertise-wrapper">
            <div className="expertise-item">
              <div className="expertise-icon">
                <i className="fas fa-industry"></i>
              </div>
              <h3>Industry Leader</h3>
              <p>High-quality big bags for all industries worldwide</p>
            </div>
            
            <div className="expertise-item">
              <div className="expertise-icon">
                <i className="fas fa-globe-europe"></i>
              </div>
              <h3>Global Reach</h3>
              <p>Warehouses and sales services across Europe</p>
            </div>
            
            <div className="expertise-item">
              <div className="expertise-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <h3>Strong Partnerships</h3>
              <p>Long-term, successful business relationships</p>
            </div>
            
            <div className="expertise-item">
              <div className="expertise-icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <h3>Innovation Focus</h3>
              <p>Continuous work on product innovations</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;